'use strict';

var $ = require('jquery');
var Marionette = require('backbone.marionette');
var TimeSelectionEvents = require('../../../analytics/time-selection-events').default;

export default Marionette.View.extend({

  tagName: 'li',
  className: 'calendar-day',
  template: require('./templates/calendar-day.hbs'),

  ui: {
    up: '.calendar-day-up',
    down: '.calendar-day-down',
    times: '.calendar-day-times',
    timeEls: '.calendar-day-time',
    next: '.calendar-day-header-next',
    back: '.calendar-day-header-back',
  },
  events: {
    'click .calendar-day-up': 'onClickUp',
    'click .calendar-day-down': 'onClickDown',
    'click .calendar-day-time a': 'onClickTime',
    'click @ui.next': 'onClickNext',
    'click @ui.back': 'onClickBack',
  },
  idealHeight: 48,

  initialize: function (options) {
    this.currentPage = 1;
    this.pageSize = 1;

    this.appointment = options.appointment;
    this.calendarCollectionStart = options.calendarCollectionStart;
    this.calendarCollectionEnd = options.calendarCollectionEnd;
  },

  onDomRefresh: function () {
    this.updateHeight();
    if (this.model.hasTimes()) {
      this.focusedTime = this.model.get('time')[0].start;
      this.updateUpAndDownButtonState();
    }
  },

  onRender: function () {
    this.updateUpAndDownButtonState();
    this.updateBackAndNextButtonState();
  },

  onClickTime: function (evt) {
    evt.preventDefault();
    var $linkEl = $(evt.currentTarget);
    var $timeEl = $linkEl.find('time');

    this.trigger('click:time', this, this.model, $timeEl.attr('datetime'));
  },

  onClickUp: function (evt) {
    evt.preventDefault();
    TimeSelectionEvents.trackClick('Up');
    this.up();
  },

  onClickDown: function (evt) {
    evt.preventDefault();
    TimeSelectionEvents.trackClick('Down');
    this.down();
  },

  updateHeight: function () {
    var height = this.ui.times.height();
    if (!height) {
      return;
    }

    var pageSize = Math.floor(height / this.idealHeight);
    if (this.pageSize === pageSize) {
      return;
    }

    this.pageSize = pageSize;
    this.ui.timeEls.each(function (key, el) {
      el.style.height = 'calc(100% / ' + pageSize + ')';
    });
  },

  select: function (time) {
    this.$el.addClass('active');
    this.focusedTime = time;
    this.setTabindexes(this.focusedTime);
    this.$('[datetime="' + time + '"]').closest('li').addClass('active');
  },

  deselectAll: function () {
    this.$el.removeClass('active');
    this.ui.timeEls.removeClass('active');
  },

  up: function () {
    if (this.currentPage <= 1) return;

    this.currentPage--;
    this.setTop();
    this.updateUpAndDownButtonState();
  },

  down: function () {
    if (this.currentPage >= this.getNumberOfPages()) return;

    this.currentPage++;
    this.setTop();
    this.updateUpAndDownButtonState();
  },

  getNumberOfPages: function () {
    var times = this.model.get('time');
    var length = times ? times.length : 0;

    return Math.ceil(length / this.pageSize);
  },

  setTop: function () {
    this.ui.times.css('top', -((this.currentPage - 1) * 100) + '%');
  },

  updateUpAndDownButtonState: function () {
    var numberOfPages = this.getNumberOfPages();

    if (this.currentPage <= 1) {
      this.ui.up.addClass('disabled');
    } else {
      this.ui.up.removeClass('disabled');
    }

    if (isNaN(numberOfPages) || this.currentPage >= numberOfPages) {
      this.ui.down.addClass('disabled');
    } else {
      this.ui.down.removeClass('disabled');
    }
  },

  updateBackAndNextButtonState: function () {
    if (this.calendarCollectionStart.isSame(this.model.get('value'), 'day')) {
      this.ui.back.addClass('disabled');
    } else {
      this.ui.back.removeClass('disabled');
    }

    if (window.SETTINGS.time_in_advance && this.calendarCollectionEnd.isSame(this.model.get('value'), 'day')) {
      this.ui.next.addClass('disabled');
    } else {
      this.ui.next.removeClass('disabled');
    }
  },

  onClickBack: function (evt) {
    evt.preventDefault();
    this.triggerMethod('back');
  },

  onClickNext: function (evt) {
    evt.preventDefault();
    this.triggerMethod('next');
  },

  //KEYBOARD NAVIGATION FUNCTIONALITY

  setFocusToFirstTime: function () {
    var firstTime = this.model.get('time')[0].start;
    this.setFocusedTime(firstTime);
  },

  navigateToPreviousTime: function () {
    if (this.model.isFirstTime(this.focusedTime)) {
      return;
    }

    var previousTime = this.model.getPreviousTime(this.focusedTime);
    if (!previousTime) {
      return;
    }

    this.setFocusedTime(previousTime);
  },

  navigateToNextTime: function () {
    if (this.model.isLastTime(this.focusedTime)) {
      return;
    }

    var nextTime = this.model.getNextTime(this.focusedTime);
    if (!nextTime) {
      return;
    }

    this.setFocusedTime(nextTime);
  },

  setFocusedTime: function (time) {
    var oldTime = this.focusedTime;
    this.focusedTime = time;
    this.setTabindexes(time, oldTime);
    var $timeElement = this.$el.find('time[datetime="' + time + '"]').parent();
    $timeElement.focus();
  },

  setTabindexes: function (time, oldTime) {
    var $timeElement = this.$el.find('time[datetime="' + time + '"]').parent();
    $timeElement.attr('tabindex', '0');

    if (oldTime && oldTime != time) {
      $timeElement = this.$el.find('time[datetime="' + oldTime + '"]').parent();
      $timeElement.attr('tabindex', '-1');
    }
  },

  removeAllTabs: function () {
    this.$el.find('time').parent().attr('tabindex', '-1');
  },

});
